import React from 'react';

import { Fab } from '@material-ui/core';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import styles from './styles.module.scss';
import { responsiveConfig } from '../../AppCollectionCarousel/config';
import { convertPixelStringToInteger } from '../../../utils/helpers';
import variables from '../../../styles/exports.module.scss';
import ctx from 'classnames';

export const TILES_TO_SHOW = 6;
export const CARDS_TO_SHOW = 3;
export const SLIDES_TO_SHOW = 1;
export const INITIAL_SLIDE = 0; 

export enum CarouselTypes {
  Slider = 'sliderCarousel',
  Tile = 'tileCarousel',
  Card = 'cardCarousel',
  Dialog = 'dialogCarousel'
}



export type CarouselType = CarouselTypes.Slider | CarouselTypes.Tile | CarouselTypes.Card | CarouselTypes.Dialog;

export const config = {
  dots: false,
  nextArrow: (
    <Fab size="medium">
      <ChevronRight />
    </Fab>
  ),
  prevArrow: (
    <Fab size="medium">
      <ChevronLeft />
    </Fab>
  ),
  slidesToScroll: 1,
  slidesToShow: TILES_TO_SHOW,
  speed: 500,
  pauseOnFocus: true,
  arrows: false,
};

export const Carousels = {
  [CarouselTypes.Slider]: {
    ...config,
    autoplay: false,
    initialSlide: INITIAL_SLIDE,
    autoplaySpeed: 5000,
    centerMode: false,
    infinite: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    slidesToShow: SLIDES_TO_SHOW,
    centerPadding: '0',
    variableWidth: false,
    dots: true,
    arrows: true,
    className: ctx(styles.carousel, styles.sliderCarousel),
    
  },

  [CarouselTypes.Dialog]: {
    ...config,
    autoplay: false,
    initialSlide: INITIAL_SLIDE,
    centerMode: false,
    infinite: false,
    slidesToShow: SLIDES_TO_SHOW,
    centerPadding: '0',
    variableWidth: false,
    dots: true,
    arrows: true,
    className: ctx(styles.carousel, styles.sliderCarousel, styles.globalDots),
  },
    
  [CarouselTypes.Tile]: {
    ...config,
    autoplay: false,
    initialSlide: INITIAL_SLIDE,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: false,
    arrows: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: convertPixelStringToInteger(variables.desktop),
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: convertPixelStringToInteger(variables.tablet),
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
        },
      }
    ],
    className: ctx(styles.carousel, styles.tileCarousel),
  },
  [CarouselTypes.Card]: {
    ...config,
    autoplay: false,
    initialSlide: INITIAL_SLIDE,
    infinite: false,
    slidesToShow: CARDS_TO_SHOW,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    mobileFirst: true,
    responsive: responsiveConfig.card,
    adaptiveHeight: true,
    className: ctx(styles.carousel, styles.cardCarousel),
  },
};
